// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"src-components-BudgetBuilder-ResearchTeam-AddMemberModal-styles___fullWidth"};